import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';

import { MAX_LENGTH } from '../constants';

const PREVIEW_STYLE_ID = 'AcmeUserCss-previewStyle';
const PREVIEW_POST_ID = 'AcmeUserCss-previewPost';

export default class CustomCssSettingsItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.value = app.session.user.customCssRaw() || '';
    this.loading = false;
  }

  view() {
    const remaining = MAX_LENGTH - this.value.length;
    const hasContent = this.value.trim().length > 0;

    return (
      <div className="Form-group AcmeUserCss-settings">
        <label>{app.translator.trans('kemze-user-css.forum.settings.label')}</label>
        <div className="helpText">{app.translator.trans('kemze-user-css.forum.settings.help_text')}</div>

        <textarea
          className="FormControl AcmeUserCss-textarea"
          rows="10"
          spellcheck="false"
          maxlength={MAX_LENGTH}
          value={this.value}
          oninput={(e) => this.onInput(e.target.value)}
        />

        <div className="AcmeUserCss-charCount">
          {app.translator.trans('kemze-user-css.forum.settings.characters_remaining', { count: remaining })}
        </div>

        {Button.component(
          {
            className: 'Button Button--primary',
            loading: this.loading,
            onclick: () => this.save(),
          },
          app.translator.trans('kemze-user-css.forum.settings.submit_button')
        )}
        {' '}
        {hasContent &&
          Button.component(
            {
              className: 'Button',
              onclick: () => this.checkWithServer(),
            },
            app.translator.trans('kemze-user-css.forum.settings.preview_button')
          )}

        {hasContent && (
          <div className="AcmeUserCss-previewWrapper">
            <label>{app.translator.trans('kemze-user-css.forum.settings.preview_label')}</label>
            <div id={PREVIEW_POST_ID} className={`AcmeUserCss-preview PostUser-${app.session.user.id()}`}>
              <div className="Post-body">
                <p>{app.translator.trans('kemze-user-css.forum.settings.preview_sample_text')}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  onInput(value) {
    this.value = value;
    // Raw and unsanitized: instant feedback while typing, never sent
    // anywhere. Wrapped in @scope so even something like `body {}` or
    // `* {}` stays confined to the sample box instead of affecting the
    // rest of this settings page.
    this.applyPreviewStyle(value ? `@scope (#${PREVIEW_POST_ID}) {\n${value}\n}` : '');
  }

  applyPreviewStyle(css) {
    let style = document.getElementById(PREVIEW_STYLE_ID);

    if (!css || !css.trim()) {
      if (style) style.remove();
      return;
    }

    if (!style) {
      style = document.createElement('style');
      style.id = PREVIEW_STYLE_ID;
      document.head.appendChild(style);
    }

    style.textContent = css;
  }

  checkWithServer() {
    app
      .request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/kemze-user-css/preview`,
        body: { css: this.value },
      })
      .then((response) => {
        // Already scoped to .PostUser-{id} server-side, and the sample
        // box below carries that same class, so no @scope wrapper
        // needed here, it applies directly.
        this.applyPreviewStyle(response.css || '');
      })
      .catch(() => {
        app.alerts.show({ type: 'error' }, app.translator.trans('kemze-user-css.forum.settings.preview_failed_message'));
      });
  }

  onremove(vnode) {
    super.onremove(vnode);

    const style = document.getElementById(PREVIEW_STYLE_ID);
    if (style) style.remove();
  }

  save() {
    this.loading = true;

    app.session.user
      .save({ customCss: this.value })
      .then(() => {
        app.alerts.show({ type: 'success' }, app.translator.trans('kemze-user-css.forum.settings.saved_message'));
      })
      .catch(() => {
        app.alerts.show({ type: 'error' }, app.translator.trans('kemze-user-css.forum.settings.save_failed_message'));
      })
      .finally(() => {
        this.loading = false;
      });
  }
}

